import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { MenuModule } from 'primeng/menu';
import { NavigationEnd, Router } from '@angular/router';
import { BaseComponent } from '../../shared/class/base-component.class';
import { MessageType } from '../../shared/enums/message-type.enum';
import { AuthService } from '../../auth/services/auth.service';
import { BehaviorSubject } from 'rxjs';
import { HOME_TABS } from '../../shared/constansts/app.const';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
})
export class NavbarComponent extends BaseComponent implements OnInit{
  tabMenus!: MenuItem[] | undefined  ;
  activeItem !:MenuItem  | null | undefined;
  userMenuItems: MenuItem[] =  [
    {
      label: 'Profile',
      icon: 'pi pi-user',
      routerLink: '/profile'
    },
    {separator: true},
    {
      label: 'Logout',
      icon: 'pi pi-sign-out',
      command: () => this.logout()
    }
  ];

  constructor(router: Router,private authservice:AuthService) {
    super()
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.setActiveItemFromUrl(event.url);
      }
    });
  }


  ngOnInit() {

    this.tabMenus = HOME_TABS.filter(tab=> this.accessService.checkAccess(tab.auth));

  let fullPath = this.router.url;
  const firstSegment = `/${fullPath.split('/')[1]}`;
  this.setActiveItemFromUrl(firstSegment);

    const token = localStorage.getItem('token');
    if(token){
      let tokenDetails = this.authservice.getDecodedToken();
      if(tokenDetails.userType!="ROOT_ADMIN"){
        this.tabMenus = this.tabMenus?.filter((val:any)=>val.label!="Settings")
      }
    }

  }

  setActiveItemFromUrl(path: string) {
    if(this.tabMenus){
      const matchingItem = this.tabMenus!.find(item => item.routerLink === path);
      if (matchingItem) {
        this.activeItem = matchingItem;
      }
    }

  }

    logout() {
      localStorage.removeItem('token');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('exp');
      this.router.navigate(['/auth/login']);
      this.notificationService.notify("Logout Successfully",MessageType.Success);
    }

}
